// Contact info masking utilities

export const maskPhone = (phone) => {
  if (!phone) return '';
  
  // Remove any non-digit characters
  const digits = phone.replace(/\D/g, '');
  
  if (digits.length <= 7) {
    return phone; // Too short to mask meaningfully
  }
  
  // Show first 4 and last 3 digits
  const firstPart = digits.substring(0, 4);
  const lastPart = digits.substring(digits.length - 3);
  const maskedMiddle = '*'.repeat(Math.min(4, digits.length - 7));
  
  return `${firstPart}${maskedMiddle}${lastPart}`;
};

export const maskEmail = (email) => {
  if (!email) return '';
  
  const parts = email.split('@');
  if (parts.length !== 2) return email;
  
  const username = parts[0];
  const domain = parts[1];
  
  if (username.length <= 2) {
    return `${username}***@${domain}`;
  }
  
  // Show first 2 characters
  const visiblePart = username.substring(0, 2);
  return `${visiblePart}***@${domain}`;
};

export const formatContactDisplay = (value, isMasked) => {
  if (!value) return 'Not available';
  return isMasked ? value : value;
};
